export default __webpack_public_path__ + "static/media/assessment.cf3cf08f.png";